// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"38b82f97","357":"8c912252","371":"1105fe7b","451":"15b5df6b","868":"3951c139"}[chunkId] + ".chunk.js";
};